exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n    color: white;\n    background-color: #2d3349 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/dialogs/leave-confirm-dialog/leave-confirm-dialog.component.css
// module id = ../../../../../src/app/dialogs/leave-confirm-dialog/leave-confirm-dialog.component.css
// module chunks = main